// ============================================================
//  Asset manifest — maps registry keys to real files on disk.
//  Paths are under /public/assets (served at /assets/...). Spaces in Kenney
//  folder names are URL-encoded. Missing files fall back to placeholders.
// ============================================================

const KA = "assets/KayKit_Adventurers_2.0_FREE/KayKit_Adventurers_2.0_FREE";
const KD = "assets/KayKit_DungeonRemastered_1.1_FREE/KayKit_DungeonRemastered_1.1_FREE/Assets/gltf";
const GY = "assets/kenney_graveyard-kit/Models/GLB%20format";
const MD = "assets/kenney_mini-dungeon/Models/GLB%20format";
const SK = "assets/KayKit_Skeletons_1.1_FREE/KayKit_Skeletons_1.1_FREE";
const RB = "assets/KayKit_ResourceBits_1.0_FREE/KayKit_ResourceBits_1.0_FREE";
const FN = "assets/KayKit_Forest_Nature_Pack_1.0_FREE/KayKit_Forest_Nature_Pack_1.0_FREE/Assets/gltf";
const HX = "assets/hex";   // KayKit Medieval Hexagon pack (converted FBX→glb; shares one atlas)
const KAX = "assets/KayKit_Adventurers_2.0_EXTRA/KayKit_Adventurers_2.0_EXTRA/Assets/gltf";   // Adventurers EXTRA weapons/props
const LW = "assets/KayKit_FantasyWeaponsBits_1.0_EXTRA/Assets/gltf";   // Legendary Memory Relic weapons
const SKX = "assets/KayKit_Skeletons_1.1_EXTRA";   // Skeletons EXTRA (bodies + bosses + rigs) — replaces FREE
const KCA = "assets/KayKit_Character_Animations_1.1/KayKit_Character_Animations_1.1/Animations/gltf";   // full KayKit animation set (combat/movement/etc.)
const KDX = "assets/KayKit_DungeonRemastered_1.1_EXTRA/KayKit_DungeonRemastered_1.1_EXTRA/Assets/gltf";  // Dungeon EXTRA decor (gltf subset)

export const MANIFEST = {
  // ---- Playable heroes (KayKit Adventurers, skinned; clips are external) ----
  "characters/knight":    `${KA}/Characters/gltf/Knight.glb`,
  "characters/barbarian": `${KA}/Characters/gltf/Barbarian.glb`,
  "characters/rogue":     `${KA}/Characters/gltf/Rogue.glb`,
  "characters/ranger":    `${KA}/Characters/gltf/Ranger.glb`,
  "characters/mage":      `${KA}/Characters/gltf/Mage.glb`,
  "characters/rogue_hooded": `${KA}/Characters/gltf/Rogue_Hooded.glb`,
  "enemies/digger":       `${GY}/character-digger.glb`,
  "enemies/skeleton":  `${GY}/character-skeleton.glb`,
  "enemies/zombie":    `${GY}/character-zombie.glb`,
  "enemies/ghost":     `${GY}/character-ghost.glb`,
  "enemies/vampire":   `${GY}/character-vampire.glb`,
  "enemies/orc":       `${MD}/character-orc.glb`,
  "enemies/human":     `${MD}/character-human.glb`,

  // ---- KayKit shared animation library (retargeted onto the Knight rig) ----
  "anim/kaykit_general":  `${KA}/Animations/gltf/Rig_Medium/Rig_Medium_General.glb`,   // Idle_A, Hit_A, Death_A...
  "anim/kaykit_movement": `${KA}/Animations/gltf/Rig_Medium/Rig_Medium_MovementBasic.glb`, // Running_A/B...

  // ---- Skeletons EXTRA: enemy bodies, bosses, weapons, and rig clips ----
  "enemies/skel_warrior": `${SKX}/characters/gltf/Skeleton_Warrior.glb`,
  "enemies/skel_rogue":   `${SKX}/characters/gltf/Skeleton_Rogue.glb`,
  "enemies/skel_mage":    `${SKX}/characters/gltf/Skeleton_Mage.glb`,
  "enemies/skel_minion":  `${SKX}/characters/gltf/Skeleton_Minion.glb`,
  "enemies/skel_golem":   `${SKX}/characters/gltf/Skeleton_Golem.glb`,
  "enemies/necromancer":  `${SKX}/characters/gltf/Necromancer.glb`,
  "skelw/axe":   `${SKX}/assets/gltf/Skeleton_Axe.gltf`,
  "skelw/blade": `${SKX}/assets/gltf/Skeleton_Blade.gltf`,
  "skelw/staff": `${SKX}/assets/gltf/Skeleton_Staff.gltf`,
  "skelw/scythe": `${SKX}/assets/gltf/Skeleton_Scythe.gltf`,
  "skelw/golem_axe": `${SKX}/assets/gltf/Skeleton_Golem_Axe_Large.gltf`,
  "anim/skel_general":  `${SKX}/Animations/gltf/Rig_Medium/Rig_Medium_General.glb`,
  "anim/skel_movement": `${SKX}/Animations/gltf/Rig_Medium/Rig_Medium_MovementBasic.glb`,
  "anim/skel_large_general":  `${SKX}/Animations/gltf/Rig_Large/Rig_Large_General.glb`,
  "anim/skel_large_movement": `${SKX}/Animations/gltf/Rig_Large/Rig_Large_MovementBasic.glb`,

  // NOTE: KayKit Character Animations combat clips (KCA) are NOT loaded yet —
  // they carry root motion that floats/locks retargeted bodies. Re-add here once
  // root motion is stripped or in-place variants are used.

  // web-spitting spider (Lowpoly Little Spider — self-contained gltf)
  "enemies/spider": `assets/spider/Spider-gltf/Spider.gltf`,

  // ---- Dungeon tileset (KayKit Dungeon Remastered, 4-unit tiles) ----
  "dungeon/floor":  `${KD}/floor_tile_large.gltf`,
  "dungeon/wall":   `${KD}/wall.gltf`,
  "dungeon/barrel": `${KD}/barrel_small.gltf`,
  "dungeon/crate":  `${KD}/crates_stacked.gltf`,
  "dungeon/column": `${KD}/column.gltf`,
  "dungeon/torch":  `${KD}/torch_lit.gltf`,
  "dungeon/chest":  `${KD}/chest.gltf`,
  "dungeon/table":  `${KD}/table_long.gltf`,

  // ---- Dungeon decor upgrade (KayKit Dungeon Remastered EXTRA) ----
  // Fills shapes the dungeon already references but previously rendered as
  // placeholders, plus a couple of variety props. ROLLBACK: delete this block
  // (bottle/candle/bed/coins/barrel_stack fall back to placeholders again).
  "dungeon/bottle":       `${KDX}/bottle_A_labeled_green.gltf`,
  "dungeon/candle":       `${KDX}/candle_triple.gltf`,
  "dungeon/bed":          `${KDX}/bed_A_single.gltf`,
  "dungeon/coins":        `${KDX}/coin_stack_medium.gltf`,
  "dungeon/barrel_stack": `${KDX}/barrel_small_stack.gltf`,
  "dungeon/bookcase":     `${KDX}/bookcase_double_decoratedA.gltf`,
  "dungeon/chest_gold":   `${KDX}/chest_gold.gltf`,
  "dungeon/chest_large":  `${KDX}/chest_large.gltf`,   // silver locked-chest tier
  "dungeon/chest_mimic":  `${KDX}/chest_mimic.gltf`,   // mimic enemy body

  // ---- Graveyard (Kenney graveyard kit) ----
  "grave/gravestone":  `${GY}/gravestone-round.glb`,
  "grave/gravestone2": `${GY}/gravestone-bevel.glb`,
  "grave/cross":       `${GY}/cross.glb`,
  "grave/crypt":       `${GY}/crypt-small.glb`,
  "grave/crypt_large": `${GY}/crypt.glb`,
  "grave/candle":      `${GY}/candle.glb`,
  "grave/coffin":      `${GY}/coffin.glb`,
  "grave/altar":       `${GY}/altar-stone.glb`,
  "grave/rocks":       `${GY}/rocks.glb`,
  "grave/deadtree":    `${GY}/gravestone-debris.glb`,

  // ---- Weapons (KayKit Adventurers) — attach to the hero hand + loot drops ----
  "weapon/sword":  `${KAX}/sword_1handed.gltf`,
  "weapon/sword2": `${KAX}/sword_2handed.gltf`,
  "weapon/axe":    `${KAX}/axe_1handed.gltf`,
  "weapon/axe2":   `${KAX}/axe_2handed.gltf`,
  "weapon/dagger": `${KAX}/dagger.gltf`,
  "weapon/bow":    `${KAX}/bow_withString.gltf`,
  "weapon/staff":  `${KAX}/staff.gltf`,
  "weapon/wand":   `${KAX}/wand.gltf`,
  "weapon/crossbow": `${KAX}/crossbow_2handed.gltf`,
  "weapon/shield": `${KAX}/shield_round.gltf`,
  "weapon/shield_square": `${KAX}/shield_square_color.gltf`,
  "weapon/shield_spikes": `${KAX}/shield_spikes_color.gltf`,
  "weapon/shield_badge":  `${KAX}/shield_badge_color.gltf`,
  "weapon/spellbook": `${KAX}/spellbook_closed.gltf`,

  // ---- Legendary Memory Relic weapons (KayKit Fantasy Weapons Bits EXTRA) ----
  "legend/sword_a": `${LW}/sword_A.gltf`, "legend/sword_b": `${LW}/sword_B.gltf`,
  "legend/sword_c": `${LW}/sword_C.gltf`, "legend/sword_d": `${LW}/sword_D.gltf`,
  "legend/sword_e": `${LW}/sword_E.gltf`, "legend/sword_f": `${LW}/sword_F.gltf`,
  "legend/sword_g": `${LW}/sword_G.gltf`,
  "legend/axe_a": `${LW}/axe_A.gltf`, "legend/axe_b": `${LW}/axe_B.gltf`,
  "legend/axe_c": `${LW}/axe_C.gltf`, "legend/axe_d": `${LW}/axe_D.gltf`,
  "legend/hammer_a": `${LW}/hammer_A.gltf`, "legend/hammer_b": `${LW}/hammer_B.gltf`,
  "legend/hammer_c": `${LW}/hammer_C.gltf`, "legend/hammer_d": `${LW}/hammer_D.gltf`,
  "legend/halberd": `${LW}/halberd.gltf`, "legend/scythe": `${LW}/scythe.gltf`,
  "legend/spear_a": `${LW}/spear_A.gltf`, "legend/spear_b": `${LW}/spear_B.gltf`,
  "legend/dagger_a": `${LW}/dagger_A.gltf`, "legend/dagger_b": `${LW}/dagger_B.gltf`,
  "legend/dagger_c": `${LW}/dagger_C.gltf`,
  "legend/staff_a": `${LW}/staff_A.gltf`, "legend/staff_b": `${LW}/staff_B.gltf`,
  "legend/staff_c": `${LW}/staff_C.gltf`, "legend/staff_d": `${LW}/staff_D.gltf`,
  "legend/wand_a": `${LW}/wand_A.gltf`, "legend/wand_b": `${LW}/wand_B.gltf`,
  "legend/bow_a": `${LW}/bow_A_withString.gltf`, "legend/bow_b": `${LW}/bow_B_withString.gltf`,
  "legend/bow_c": `${LW}/bow_C_withString.gltf`,

  // ---- Consumables (KayKit bottles used as potions) ----
  "potion/health":  `${KD}/bottle_A_labeled_green.gltf`,
  "potion/greater": `${KD}/bottle_B_green.gltf`,
  "potion/mana":    `${KD}/bottle_C_brown.gltf`,   // (no blue bottle in the pack — tinted in UI)
  "adv/mug":        `${KAX}/mug_full.gltf`,

  // ---- Food (Kenney Food Kit — converted from FBX, tinted a solid colour at runtime) ----
  "food/apple":     "assets/food/apple.glb",
  "food/bread":     "assets/food/bread.glb",
  "food/cheese":    "assets/food/cheese.glb",
  "food/banana":    "assets/food/banana.glb",
  "food/carrot":    "assets/food/carrot.glb",
  "food/cookie":    "assets/food/cookie.glb",
  "food/croissant": "assets/food/croissant.glb",
  "food/corn":      "assets/food/corn.glb",
  "food/cupcake":   "assets/food/cupcake.glb",
  "food/burger":    "assets/food/burger.glb",
  "food/soup":      "assets/food/bowl-soup.glb",
  "food/cake":      "assets/food/cake.glb",
  "food/coffee":    "assets/food/cup-coffee.glb",
  "food/bacon":     "assets/food/bacon.glb",

  // ---- Relics / treasure (Binbun Treasure_Free — native glTF, embedded textures) ----
  "relic/scroll_sealed": "assets/Treasure_Free/Free/GLTF/Scroll/Sealed_Scroll/Sealed_Scroll_01.glb",
  "relic/scroll_metal":  "assets/Treasure_Free/Free/GLTF/Scroll/Metal_Scroll/Metal_Scroll_01.glb",
  "relic/scroll_basic":  "assets/Treasure_Free/Free/GLTF/Scroll/Basic_Scroll/Basic_Scroll_01.glb",
  "relic/gem_diamond":   "assets/Treasure_Free/Free/GLTF/Gems/Diamond/Diamond_01.glb",
  "relic/gem_emerald":   "assets/Treasure_Free/Free/GLTF/Gems/Emerald/Emerald_01.glb",
  "relic/gem_topaz":     "assets/Treasure_Free/Free/GLTF/Gems/Topaz/Topaz_01.glb",
  "relic/ring":          "assets/Treasure_Free/Free/GLTF/Jewelry/Silver_Ring/Silver_Ring_01.glb",
  "relic/ring_gem":      "assets/Treasure_Free/Free/GLTF/Jewelry/Silver_Gem_Ring/Silver_Gem_Ring_01.glb",
  "relic/key_gold":      "assets/Treasure_Free/Free/GLTF/Keys/Gold_Key/Gold_Key_01.glb",
  "relic/key_skeleton":  "assets/Treasure_Free/Free/GLTF/Keys/Skeleton_Key/Skeleton_Key_01.glb",
  "relic/coins_mega":    "assets/Treasure_Free/Free/GLTF/Coins/Mega_Gold_Coin/Mega_Gold_Coin_01.glb",
  "relic/chest":         "assets/Treasure_Free/Free/GLTF/Chest/Basic_Chest/Basic_Chest_Full.glb",

  // ---- Creatures (Quaternius Ultimate Monsters — native glTF, shared atlas) ----
  //  pets
  "creatures/dragon":    "assets/creatures/Flying/glTF/Dragon.gltf",
  "creatures/ghost":     "assets/creatures/Flying/glTF/Ghost.gltf",
  "creatures/armabee":   "assets/creatures/Flying/glTF/Armabee.gltf",
  "creatures/greenblob": "assets/creatures/Blob/glTF/GreenBlob.gltf",
  "creatures/cat":       "assets/creatures/Blob/glTF/Cat.gltf",
  "creatures/mushnub":   "assets/creatures/Blob/glTF/Mushnub.gltf",
  //  enemies (used when FEATURES.monsters is on)
  "creatures/orc":       "assets/creatures/Big/glTF/Orc.gltf",
  "creatures/demon":     "assets/creatures/Big/glTF/Demon.gltf",
  "creatures/yeti":      "assets/creatures/Big/glTF/Yeti.gltf",
  "creatures/spikyblob": "assets/creatures/Blob/glTF/GreenSpikyBlob.gltf",
  "gear/lantern":   `${GY}/lantern-glass.glb`,        // belt lantern (player light source)

  // ---- Village hub (KayKit Medieval Hexagon, converted; textured via hex/atlas.png) ----
  "hex/blacksmith": `${HX}/blacksmith.glb`,
  "hex/home":       `${HX}/home.glb`,
  "hex/shop":       `${HX}/shop.glb`,
  "hex/church":     `${HX}/church.glb`,
  "hex/tree_a":     `${HX}/tree_a.glb`,
  "hex/tree_b":     `${HX}/tree_b.glb`,
  "hex/rock_a":     `${HX}/rock_a.glb`,
  "hex/rock_c":     `${HX}/rock_c.glb`,
  "hex/barrel":     `${HX}/barrel.glb`,
  "hex/crate":      `${HX}/crate.glb`,
  "hex/sack":       `${HX}/sack.glb`,
  "hex/weaponrack": `${HX}/weaponrack.glb`,
  "hex/tent":       `${HX}/tent.glb`,
  "hex/flag":       `${HX}/flag.glb`,
  "hex/bucket":     `${HX}/bucket.glb`,
  "hex/fence":      `${HX}/fence.glb`,
  "hex/fence_gate": `${HX}/fence_gate.glb`,
  "hex/tile_grass": `${HX}/tile_grass.glb`,
  "hex/tile_water": `${HX}/tile_water.glb`,
  "hex/road_a":     `${HX}/road_hex_road_A.glb`,
  "hex/coast_a":    `${HX}/coast_hex_coast_A.glb`,

  // ---- Extra dungeon decor + destructibles + wall torch ----
  "dungeon/barrel_large": `${KD}/barrel_large.gltf`,
  "dungeon/barrel_stack": `${KD}/barrel_small_stack.gltf`,
  "dungeon/bottle":       `${KD}/bottle_A_brown.gltf`,
  "dungeon/candle":       `${KD}/candle_lit.gltf`,
  "dungeon/coins":        `${KD}/coin_stack_small.gltf`,
  "dungeon/torch_wall":   `${KD}/torch_mounted.gltf`,
  // floor + wall variety (remodel)
  "dungeon/floor_rocks":  `${KD}/floor_tile_large_rocks.gltf`,
  "dungeon/floor_dirt":   `${KD}/floor_dirt_large.gltf`,
  "dungeon/wall_arched":  `${KD}/wall_arched.gltf`,
  "dungeon/wall_window":  `${KD}/wall_archedwindow_gated.gltf`,
  "dungeon/wall_corner":  `${KD}/wall_corner.gltf`,
  "dungeon/bed":          `${KD}/bed_decorated.gltf`,
  "dungeon/banner":       `${KD}/banner_red.gltf`,
  "dungeon/door":         `${KD}/wall_gated.gltf`,   // portcullis gate (interactable, V)
  // ---- Hub / Waystation interior decor ----
  "hub/floor_wood":  `${KD}/floor_wood_large.gltf`,
  "hub/weaponrack":  `${KD}/sword_shield.gltf`,
  "hub/shelf":       `${KD}/shelf_large.gltf`,
  "hub/shelf_candles": `${KD}/shelf_small_candles.gltf`,
  "hub/keg":         `${KD}/keg_decorated.gltf`,
  "hub/stool":       `${KD}/stool.gltf`,
  "hub/chair":       `${KD}/chair.gltf`,
  "hub/counter":     `${KD}/table_long_decorated_A.gltf`,
  "hub/coins":       `${KD}/coin_stack_large.gltf`,
  "hub/anvil_barrel": `${KD}/barrel_large_decorated.gltf`,

  // ---- Forest / wilderness (KayKit Forest Nature Pack) ----
  "forest/tree_a":     `${FN}/Tree_1_A_Color1.gltf`,
  "forest/tree_b":     `${FN}/Tree_2_A_Color1.gltf`,
  "forest/tree_c":     `${FN}/Tree_2_C_Color1.gltf`,
  "forest/tree_tall":  `${FN}/Tree_3_A_Color1.gltf`,
  "forest/tree_d":     `${FN}/Tree_4_A_Color1.gltf`,
  "forest/deadtree":   `${FN}/Tree_Bare_1_A_Color1.gltf`,
  "forest/deadtree2":  `${FN}/Tree_Bare_2_A_Color1.gltf`,
  "forest/rock_sm":    `${FN}/Rock_1_A_Color1.gltf`,
  "forest/rock_sm2":   `${FN}/Rock_1_H_Color1.gltf`,
  "forest/rock_md":    `${FN}/Rock_2_A_Color1.gltf`,
  "forest/rock_md2":   `${FN}/Rock_2_E_Color1.gltf`,
  "forest/boulder":    `${FN}/Rock_3_A_Color1.gltf`,
  "forest/boulder2":   `${FN}/Rock_3_D_Color1.gltf`,
  "forest/boulder3":   `${FN}/Rock_3_G_Color1.gltf`,
  "forest/boulder4":   `${FN}/Rock_3_K_Color1.gltf`,
  "forest/boulder5":   `${FN}/Rock_3_Q_Color1.gltf`,
  "forest/bush_a":     `${FN}/Bush_1_A_Color1.gltf`,
  "forest/bush_b":     `${FN}/Bush_2_A_Color1.gltf`,
  "forest/bush_c":     `${FN}/Bush_4_A_Color1.gltf`,
  "forest/bush_d":     `${FN}/Bush_3_A_Color1.gltf`,
  "forest/grass":      `${FN}/Grass_1_A_Color1.gltf`,
  "forest/grass2":     `${FN}/Grass_2_A_Color1.gltf`,
  "forest/grass3":     `${FN}/Grass_1_C_Color1.gltf`,
  // camp loot + firelight (reuse dungeon pack)
  "dungeon/barrel_large": `${KD}/barrel_large.gltf`,
  "dungeon/keg":          `${KD}/keg_decorated.gltf`,
  "dungeon/bedroll":      `${KD}/bed_floor.gltf`,
  "dungeon/campfire":     `${KD}/torch_lit.gltf`,

  // ---- KayKit Skeletons (dungeon enemies) + their shared animation rig ----
  "enemies/skel_warrior": `${SK}/characters/gltf/Skeleton_Warrior.glb`,
  "enemies/skel_rogue":   `${SK}/characters/gltf/Skeleton_Rogue.glb`,
  "enemies/skel_mage":    `${SK}/characters/gltf/Skeleton_Mage.glb`,
  "enemies/skel_minion":  `${SK}/characters/gltf/Skeleton_Minion.glb`,
  "anim/skel_general":    `${SK}/Animations/gltf/Rig_Medium/Rig_Medium_General.glb`,
  "anim/skel_movement":   `${SK}/Animations/gltf/Rig_Medium/Rig_Medium_MovementBasic.glb`,
  "skelw/axe":            `${SK}/assets/gltf/Skeleton_Axe.gltf`,
  "skelw/blade":          `${SK}/assets/gltf/Skeleton_Blade.gltf`,
  "skelw/staff":          `${SK}/assets/gltf/Skeleton_Staff.gltf`,

  // ---- Resource bits (crafting materials for loot tables) ----
  "resource/copper_nugget": `${RB}/Assets/gltf/Copper_Nugget_Small.gltf`,
  "resource/copper_bar":    `${RB}/Assets/gltf/Copper_Bar.gltf`,
};
